import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import eDevletLogo from "../../../assets/images/e-devlet-logo.svg";
import RxButton from "../../../components/RxButton";
import RxDialog, { RxDialogState } from "../../../components/RxDialog/RxDialog";
import RxTypography from "../../../components/RxTypography";

interface BarcodeInfoDialogProps {
	show: boolean;
	licenceType: string;
	onClose: () => void;
}

const BarcodeInfoDialog = (props: BarcodeInfoDialogProps) => {
	const [dialogState, setDialogState] = useState<RxDialogState>({
		isOpen: false,
		status: "info",
		title: "",
		message: "",
	});

	useEffect(() => {
		setDialogState((prevSate: RxDialogState) => {
			return { ...prevSate, isOpen: props.show };
		});
	}, [props.show]);

	const eDevletDocumentLink = () => {
		if (props.licenceType === "student") {
			return "https://www.turkiye.gov.tr/yok-ogrenci-belgesi-sorgulama";
		} else {
			return "https://www.turkiye.gov.tr/yok-ogretim-elemani-belgesi-sorgulama";
		}
	};

	return (
		<RxDialog title="" open={dialogState.isOpen} actions={<></>}>
			<Grid justifyContent="center" container spacing={1}>
				<Grid item xs={12}>
					<RxTypography
						label="Belge Barkoduna Nereden Ulaşabilirim?"
						variant="h6"
						align="justify"
					/>
				</Grid>
				<a href={eDevletDocumentLink()} target="_blank" rel="noreferrer">
					<img src={eDevletLogo} alt="E-Devlet" />
				</a>
				<Grid item xs={12}>
					<RxTypography
						label={
							<>
								Belge barkodu, E-Devlet üzerinden üretilmiş YÖK{" "}
								{props.licenceType === "student"
									? "Öğrenci "
									: "Öğretim Elemanı "}
								Belgesi'nde sağ üst köşede yer almaktadır. İlgili
								belgeyi{" "}
								<a
									href={eDevletDocumentLink()}
									target="_blank"
									rel="noreferrer"
								>
									buradan
								</a>{" "}
								alabilirsiniz.
							</>
						}
						variant="subtitle1"
						align="justify"
					/>
				</Grid>
				<Grid item xs={12}>
					<RxButton
						fullWidth
						label="Tamam"
						variant="contained"
						color="primary"
						onClick={() => props.onClose()}
					/>
				</Grid>
			</Grid>
		</RxDialog>
	);
};

export default BarcodeInfoDialog;
